import { Controller } from "@hotwired/stimulus"

// The pinned result under the calculation drawer: a compact bar that is always visible
// and a breakdown that opens on demand. Lives on the wrapper AROUND the summary fragment
// because the live preview replaces that fragment wholesale — the targets reconnect on
// every swap and pick the state up from here, so the breakdown does not snap shut while
// typing.
//
// The choice is remembered per browser: someone who wants the breakdown open wants it on
// the next position too.
const STORAGE_KEY = "costing_summary_expanded"

export default class extends Controller {
  static targets = ["details", "toggle", "icon"]

  initialize() {
    this.expanded = this.readState()
  }

  toggle() {
    this.expanded = !this.expanded
    this.writeState()
    this.apply()
  }

  detailsTargetConnected() {
    this.apply()
  }

  toggleTargetConnected() {
    this.apply()
  }

  apply() {
    this.detailsTargets.forEach((details) => details.classList.toggle("hidden", !this.expanded))
    this.toggleTargets.forEach((toggle) =>
      toggle.setAttribute("aria-expanded", String(this.expanded)),
    )
    this.iconTargets.forEach((icon) => icon.classList.toggle("rotate-180", this.expanded))
  }

  readState() {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true"
    } catch {
      return false
    }
  }

  writeState() {
    try {
      localStorage.setItem(STORAGE_KEY, String(this.expanded))
    } catch {
      // Private mode or blocked storage: the toggle still works, it is just not remembered.
    }
  }
}
